module.exports = __webpack_public_path__ + "static/media/userBlack.29479ba0.png";